<template>
	<div
		class="lg:ts-col-span-5 ts-p-6 ts-border-b lg:ts-border-b-0 lg:ts-border-r ts-border-slate-100 dark:ts-border-slate-700">
		<h2 class="ts-font-semibold ts-text-slate-700 dark:ts-text-slate-200 ts-mb-6 ts-flex ts-items-center ts-gap-2">
			<span class="material-icons ts-text-sm">edit</span>
			{{ $t('invoiceAdjustment.adjustmentInput') }}
		</h2>
		<div class="ts-space-y-6">
			<div class="ts-grid ts-grid-cols-2 md:ts-grid-cols-2 ts-gap-4">
				<div>
					<label class="ts-text-xs ts-font-semibold ts-text-gray-500 ts-uppercase required">{{
						$t('invoiceAdjustment.date') }}</label>
					<a-date-picker :style="{ width: '100%' }" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
						v-model="model.adj_date" :allowClear="false" />
					<p v-if="errors.has('adj_date')" class="ts-text-red-500 ts-mt-1">{{ errors.first('adj_date')
					}}</p>
				</div>
				<div>
					<label class="ts-text-xs ts-font-semibold ts-text-gray-500 ts-uppercase required">{{
						$t('invoiceAdjustment.newClass') }}</label>
					<a-select v-model="model.new_class_id" :options="classOption" @change="onClassChange" :showSearch="true"
						:filterOption="filterOption" class="ts-w-full"></a-select>
					<p v-if="errors.has('new_class_id')" class="ts-text-red-500 ts-mt-1">{{ errors.first('new_class_id')
					}}</p>
				</div>

				<div class="ts-col-span-2">
					<label class="ts-text-xs ts-font-semibold ts-text-gray-500 ts-uppercase required">{{
						$t('invoiceAdjustment.descriptionRemark') }}</label>
					<a-textarea v-model="model.descriptions" :auto-size="{ minRows: 3, maxRows: 5 }" />
					<p v-if="errors.has('descriptions')" class="ts-text-red-500 ts-mt-1">{{ errors.first('descriptions')
					}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Errors } from 'form-backend-validation';

export default {
	name: "AdjustmentInput",
	props: {
		value: {
			type: Object,
			default: () => ({
				newClass: undefined,
				description: ''
			})
		},
		classes: {
			type: Object | Array,
			default: () => []
		},
		errors: {
			default: () => new Errors()
		}
	},
	data() {
		return {
			model: {}
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		classOption() {
			return this.classes.map((el) => ({
				value: el.class_id,
				label: `${el.class_name} ${el.class_desc} (${el.room_name}) — ${el.lname_foreign} ${el.fname_foreign}`,
				data: el
			}))
		}
	},
	methods: {
		onClassChange(value, options) {
			this.$emit('on-change', options.data.props)
		},
		filterOption(input, option) {
			return option.componentOptions.children[0].text
				.toLowerCase()
				.indexOf(input.toLowerCase()) >= 0
		},
	}
}
</script>
